// Embedded OBJ file data for Annihilator mech parts
// This allows us to store the 3D model data directly in the VFS

export const bodyOBJ = `v 160.000 457.000 -172.000
v 254.000 337.000 -199.000
v 254.000 433.000 -141.000
v -254.000 433.000 -141.000
v -254.000 337.000 -199.000
v -160.000 457.000 -172.000
v 161.000 337.000 -235.000
v 254.000 127.000 -143.000
v -254.000 127.000 -143.000
v -161.000 337.000 -235.000
v 168.000 116.000 136.000
v 226.000 184.000 261.000
v 254.000 127.000 130.000
v -254.000 127.000 130.000
v -226.000 184.000 261.000
v -168.000 116.000 136.000
v 105.000 177.000 322.000
v 104.000 308.000 319.000
v -226.000 291.000 258.000
v -105.000 177.000 322.000
v 226.000 372.000 180.000
v 226.000 291.000 258.000
v -226.000 372.000 180.000
v -104.000 308.000 319.000
v 104.000 413.000 235.000
v 159.000 457.000 124.000
v -159.000 457.000 124.000
v -104.000 413.000 235.000
v 166.000 116.000 -157.000
v -166.000 116.000 -157.000
v 254.000 433.000 87.000
v -254.000 433.000 87.000
v -128.000 95.000 -99.000
v 128.000 95.000 -99.000
v 171.000 116.000 -157.000
v -171.000 116.000 -157.000
v -171.000 116.000 136.000
v 171.000 116.000 136.000
v 128.000 95.000 99.000
v -128.000 95.000 99.000
v 0.000 457.000 -172.000
v 56.000 609.000 66.000
v -56.000 609.000 66.000
v -56.000 609.000 66.000
v 56.000 609.000 66.000
v 169.000 457.000 66.000
v -169.000 457.000 66.000
v 226.000 184.000 261.000
v 226.000 372.000 180.000
v 254.000 127.000 130.000
v -254.000 127.000 130.000
v -226.000 291.000 258.000
v -226.000 184.000 261.000
v -254.000 433.000 87.000
v -226.000 372.000 180.000
v 254.000 433.000 87.000
v 254.000 433.000 -141.000
v 254.000 337.000 -199.000
v 254.000 127.000 -143.000
v -254.000 127.000 -143.000
v -254.000 337.000 -199.000
v -254.000 433.000 -141.000
v 226.000 291.000 258.000
v 0.000 457.000 -172.000
v 169.000 457.000 66.000
v 56.000 609.000 66.000
v 0.000 457.000 -172.000
v -56.000 609.000 66.000
v -169.000 457.000 66.000
v 166.000 116.000 -157.000
v 168.000 116.000 136.000
v 254.000 127.000 -143.000
v -254.000 127.000 -143.000
v -254.000 127.000 130.000
v -166.000 116.000 -157.000
v 254.000 127.000 130.000
v -168.000 116.000 136.000
v -159.000 457.000 124.000
v 159.000 457.000 124.000
v 104.000 413.000 235.000
v -104.000 413.000 235.000
v 160.000 457.000 -172.000
v 254.000 433.000 -141.000
v 254.000 433.000 87.000
v -160.000 457.000 -172.000
v -254.000 433.000 -141.000
v -254.000 433.000 87.000
v -113.000 529.000 66.000
v -56.000 528.000 218.000
v 56.000 528.000 218.000
v 113.000 529.000 66.000
v 56.000 609.000 66.000
v 28.000 594.000 180.000
v -28.000 594.000 180.000
v -56.000 609.000 66.000
v -171.000 116.000 -157.000
v 171.000 116.000 -157.000
v 171.000 116.000 136.000
v -171.000 116.000 136.000
v 128.000 95.000 99.000
v 128.000 95.000 -99.000
v -128.000 95.000 -99.000
v -128.000 95.000 99.000
v 128.000 95.000 99.000
v 171.000 116.000 136.000
v 171.000 116.000 -157.000
v 128.000 95.000 -99.000
v -128.000 95.000 99.000
v -128.000 95.000 -99.000
v -171.000 116.000 -157.000
v -171.000 116.000 136.000
vt 0.288 0.694
vt 0.312 0.464
vt 0.312 0.647
f 1/1 2/2 3/3
vt 0.187 0.647
vt 0.187 0.464
vt 0.210 0.694
f 4/4 5/5 6/6
vt 0.288 0.464
vt 0.312 0.052
vt 0.312 0.464
f 7/7 8/8 2/9
vt 0.187 0.464
vt 0.187 0.052
vt 0.210 0.464
f 5/10 9/11 10/12
vt 0.333 0.036
vt 0.318 0.163
vt 0.312 0.052
f 11/13 12/14 13/15
vt 0.437 0.052
vt 0.430 0.163
vt 0.415 0.036
f 14/16 15/17 16/18
vt 0.348 0.155
vt 0.349 0.409
vt 0.318 0.163
f 17/19 18/20 12/21
vt 0.430 0.163
vt 0.430 0.377
vt 0.400 0.155
f 15/22 19/23 20/24
vt 0.349 0.409
vt 0.318 0.528
vt 0.318 0.377
f 18/25 21/26 22/27
vt 0.430 0.377
vt 0.430 0.528
vt 0.399 0.409
f 19/28 23/29 24/30
vt 0.349 0.607
vt 0.335 0.694
vt 0.318 0.528
f 25/31 26/32 21/33
vt 0.430 0.528
vt 0.413 0.694
vt 0.399 0.607
f 23/34 27/35 28/36
vt 0.288 0.464
vt 0.312 0.464
vt 0.288 0.694
f 7/37 2/38 1/39
vt 0.210 0.464
vt 0.288 0.464
vt 0.288 0.694
vt 0.210 0.694
f 10/40 7/41 1/42 6/43
vt 0.210 0.694
vt 0.187 0.464
vt 0.210 0.464
f 6/44 5/45 10/46
vt 0.290 0.036
vt 0.312 0.052
vt 0.288 0.464
f 29/47 8/48 7/49
vt 0.208 0.036
vt 0.290 0.036
vt 0.288 0.464
vt 0.210 0.464
f 30/50 29/51 7/52 10/53
vt 0.210 0.464
vt 0.187 0.052
vt 0.208 0.036
f 10/54 9/55 30/56
vt 0.348 0.155
vt 0.318 0.163
vt 0.333 0.036
f 17/57 12/58 11/59
vt 0.400 0.155
vt 0.348 0.155
vt 0.333 0.036
vt 0.415 0.036
f 20/60 17/61 11/62 16/63
vt 0.415 0.036
vt 0.430 0.163
vt 0.400 0.155
f 16/64 15/65 20/66
vt 0.318 0.163
vt 0.349 0.409
vt 0.318 0.377
f 12/67 18/68 22/69
vt 0.399 0.409
vt 0.349 0.409
vt 0.348 0.155
vt 0.400 0.155
f 24/70 18/71 17/72 20/73
vt 0.400 0.155
vt 0.430 0.377
vt 0.399 0.409
f 20/74 19/75 24/76
vt 0.349 0.607
vt 0.318 0.528
vt 0.349 0.409
f 25/77 21/78 18/79
vt 0.399 0.607
vt 0.349 0.607
vt 0.349 0.409
vt 0.399 0.409
f 28/80 25/81 18/82 24/83
vt 0.399 0.409
vt 0.430 0.528
vt 0.399 0.607
f 24/84 23/85 28/86
vt 0.318 0.528
vt 0.335 0.694
vt 0.312 0.647
f 21/87 26/88 31/89
vt 0.437 0.647
vt 0.413 0.694
vt 0.430 0.528
f 32/90 27/91 23/92
vt 0.093 -0.004
vt 0.155 -0.004
vt 0.166 0.036
vt 0.082 0.036
f 33/93 34/94 35/95 36/96
vt 0.166 0.036
vt 0.082 0.036
vt 0.093 -0.004
vt 0.155 -0.004
f 37/97 38/98 39/99 40/100
vt 0.499 0.694
vt 0.512 0.996
vt 0.486 0.996
f 41/101 42/102 43/103
vt 0.637 0.996
vt 0.611 0.996
vt 0.582 0.694
vt 0.666 0.694
f 44/104 45/105 46/106 47/107
vt 0.812 0.107
vt 0.789 0.496
vt 0.776 -0.004
f 48/108 49/109 50/110
vt 0.722 -0.004
vt 0.687 0.329
vt 0.687 0.107
f 51/111 52/112 53/113
vt 0.687 0.329
vt 0.734 0.623
vt 0.709 0.496
f 52/114 54/115 55/116
vt 0.776 -0.004
vt 0.764 0.623
vt 0.703 0.623
vt 0.687 0.425
vt 0.702 -0.004
f 50/117 56/118 57/119 58/120 59/121
vt 0.734 0.623
vt 0.722 -0.004
vt 0.796 -0.004
vt 0.812 0.425
vt 0.795 0.623
f 54/122 51/123 60/124 61/125 62/126
vt 0.789 0.496
vt 0.812 0.107
vt 0.811 0.329
f 49/127 48/128 63/129
vt 0.776 -0.004
vt 0.789 0.496
vt 0.764 0.623
f 50/130 49/131 56/132
vt 0.722 -0.004
vt 0.734 0.623
vt 0.687 0.329
f 51/133 54/134 52/135
vt 0.319 0.678
vt 0.383 0.678
vt 0.383 0.996
f 64/136 65/137 66/138
vt 0.429 0.678
vt 0.365 0.996
vt 0.365 0.678
f 67/139 68/140 69/141
vt 0.083 0.028
vt 0.083 0.750
vt 0.062 0.068
f 70/142 71/143 72/144
vt 0.187 0.068
vt 0.187 0.734
vt 0.165 0.028
f 73/145 74/146 75/147
vt 0.062 0.068
vt 0.083 0.750
vt 0.062 0.734
f 72/148 71/149 76/150
vt 0.165 0.028
vt 0.187 0.734
vt 0.165 0.750
f 75/151 74/152 77/153
vt 0.335 0.718
vt 0.413 0.718
vt 0.399 0.996
vt 0.349 0.996
f 78/154 79/155 80/156 81/157
vt 0.413 -0.004
vt 0.437 0.068
vt 0.437 0.631
vt 0.413 0.718
f 82/158 83/159 84/160 79/161
vt 0.335 -0.004
vt 0.413 -0.004
vt 0.413 0.718
vt 0.335 0.718
f 85/162 82/163 79/164 78/165
vt 0.312 0.068
vt 0.335 -0.004
vt 0.335 0.718
vt 0.312 0.631
f 86/166 85/167 78/168 87/169
vt 0.776 0.575
vt 0.762 0.948
vt 0.736 0.948
vt 0.721 0.575
f 88/170 89/171 90/172 91/173
vt 0.387 0.575
vt 0.380 0.853
vt 0.368 0.853
vt 0.361 0.575
f 92/174 93/175 94/176 95/177
vt 0.541 0.028
vt 0.457 0.028
vt 0.457 0.750
vt 0.541 0.750
f 96/178 97/179 98/180 99/181
vt 0.093 0.655
vt 0.093 0.171
vt 0.155 0.171
vt 0.155 0.655
f 100/182 101/183 102/184 103/185
vt 0.131 0.496
vt 0.124 0.996
vt 0.187 0.996
vt 0.174 0.496
f 104/186 105/187 106/188 107/189
vt 0.131 0.496
vt 0.174 0.496
vt 0.187 0.996
vt 0.124 0.996
f 108/190 109/191 110/192 111/193
`;

export const hipsOBJ = `v -128.000 -102.000 132.000
v 128.000 -102.000 132.000
v 128.000 -102.000 -99.000
v -128.000 -102.000 -99.000
v -128.000 95.000 -99.000
v 128.000 95.000 -99.000
v 128.000 95.000 99.000
v -128.000 95.000 99.000
v 128.000 95.000 99.000
v 128.000 95.000 -99.000
v 128.000 62.000 -132.000
v 128.000 -102.000 -99.000
v 128.000 -102.000 132.000
v 128.000 29.000 132.000
v -128.000 62.000 -132.000
v -128.000 95.000 -99.000
v -128.000 95.000 99.000
v -128.000 29.000 132.000
v -128.000 -102.000 132.000
v -128.000 -102.000 -99.000
v 128.000 62.000 -132.000
v -128.000 62.000 -132.000
v -128.000 29.000 132.000
v 128.000 29.000 132.000
v 128.000 -102.000 132.000
v -128.000 -102.000 132.000
v -128.000 95.000 99.000
v 128.000 95.000 99.000
v 128.000 95.000 -99.000
v -128.000 95.000 -99.000
vt -0.000 0.496
vt 0.062 0.496
vt 0.062 -0.004
vt -0.000 -0.004
f 1/1 2/2 3/3 4/4
vt 0.062 -0.004
vt 0.124 -0.004
vt 0.124 0.425
vt 0.062 0.425
f 5/5 6/6 7/7 8/8
vt 0.242 0.496
vt 0.194 0.496
vt 0.187 0.409
vt 0.194 -0.004
vt 0.249 -0.004
vt 0.249 0.329
f 9/9 10/10 11/11 12/12 13/13 14/14
vt 0.249 0.409
vt 0.242 0.496
vt 0.194 0.496
vt 0.187 0.329
vt 0.187 -0.004
vt 0.242 -0.004
f 15/15 16/16 17/17 18/18 19/19 20/20
vt 0.187 -0.004
vt 0.249 -0.004
vt 0.249 0.409
vt 0.187 0.409
f 4/21 3/22 21/23 22/24
vt 0.249 0.329
vt 0.187 0.329
vt 0.187 -0.004
vt 0.249 -0.004
f 23/25 24/26 25/27 26/28
vt 0.249 0.496
vt 0.187 0.496
vt 0.187 0.329
vt 0.249 0.329
f 27/29 28/30 24/31 23/32
vt 0.187 0.409
vt 0.249 0.409
vt 0.249 0.496
vt 0.187 0.496
f 22/33 21/34 29/35 30/36
`;

export const leftArmOBJ = `v -437.000 391.000 -41.000
v -253.000 424.000 -62.000
v -253.000 424.000 25.000
v -437.000 391.000 3.000
v -253.000 260.000 -105.000
v -437.000 326.000 -56.000
v -437.000 326.000 18.000
v -253.000 260.000 67.000
v -533.000 124.000 85.000
v -365.000 300.000 20.000
v -446.000 101.000 71.000
v -563.000 67.000 46.000
v -407.000 315.000 -19.000
v -531.000 14.000 14.000
v -364.000 299.000 -57.000
v -462.000 30.000 24.000
v -297.000 275.000 -76.000
v -298.000 276.000 40.000
v -590.000 47.000 398.000
v -538.000 131.000 92.000
v -558.000 142.000 400.000
v -482.000 -6.000 398.000
v -487.000 12.000 15.000
v -383.000 56.000 399.000
v -430.000 148.000 400.000
v -453.000 136.000 92.000
v -560.000 55.000 41.000
v -421.000 63.000 41.000
v -553.000 87.000 530.000
v -504.000 125.000 399.000
v -507.000 99.000 530.000
v -553.000 50.000 530.000
v -573.000 37.000 398.000
v -507.000 39.000 529.000
v -504.000 17.000 398.000
v -479.000 69.000 530.000
v -573.000 104.000 399.000
v -461.000 71.000 398.000
v -479.000 69.000 530.000
v -507.000 39.000 529.000
v -553.000 50.000 530.000
v -553.000 87.000 530.000
v -507.000 99.000 530.000
v -391.000 65.000 496.000
v -417.000 38.000 496.000
v -459.000 48.000 496.000
v -459.000 82.000 496.000
v -417.000 92.000 497.000
v -459.000 83.000 401.000
v -417.000 94.000 402.000
v -417.000 92.000 497.000
v -459.000 82.000 496.000
v -459.000 49.000 401.000
v -459.000 48.000 496.000
v -417.000 39.000 401.000
v -417.000 38.000 496.000
v -391.000 66.000 401.000
v -391.000 65.000 496.000
v -462.000 30.000 24.000
v -563.000 67.000 46.000
v -446.000 101.000 71.000
v -533.000 124.000 85.000
v -531.000 14.000 14.000
v -430.000 148.000 400.000
v -383.000 56.000 399.000
v -482.000 -6.000 398.000
v -590.000 47.000 398.000
v -558.000 142.000 400.000
v -421.000 63.000 41.000
v -560.000 55.000 41.000
v -487.000 12.000 15.000
v -453.000 136.000 92.000
v -538.000 131.000 92.000
v -253.000 260.000 67.000
v -437.000 326.000 18.000
v -253.000 424.000 25.000
v -437.000 391.000 -41.000
v -437.000 326.000 -56.000
v -253.000 424.000 -62.000
v -437.000 391.000 3.000
v -437.000 326.000 -56.000
v -437.000 391.000 -41.000
v -437.000 391.000 3.000
v -437.000 326.000 18.000
v -253.000 424.000 -62.000
v -253.000 260.000 -105.000
v -253.000 260.000 67.000
v -253.000 424.000 25.000
vt 0.312 0.678
vt 0.374 0.615
vt 0.374 0.869
vt 0.312 0.805
f 1/1 2/2 3/3 4/4
vt 0.249 0.496
vt 0.187 0.631
vt 0.187 0.853
vt 0.249 0.996
f 5/5 6/6 7/7 8/8
vt 0.138 0.266
vt 0.132 0.893
vt 0.120 0.321
f 9/9 10/10 11/11
vt 0.144 0.091
vt 0.164 0.877
vt 0.138 0.266
f 12/12 13/13 9/14
vt 0.146 0.004
vt 0.185 0.893
vt 0.144 0.091
f 14/15 15/16 12/17
vt 0.103 0.131
vt 0.075 0.924
vt 0.146 0.004
f 16/18 17/19 14/20
vt 0.120 0.321
vt 0.103 0.924
vt 0.103 0.131
f 11/21 18/22 16/23
vt 0.120 0.321
vt 0.132 0.893
vt 0.103 0.924
f 11/24 10/25 18/26
vt 0.138 0.266
vt 0.164 0.877
vt 0.132 0.893
f 9/27 13/28 10/29
vt 0.144 0.091
vt 0.185 0.893
vt 0.164 0.877
f 12/30 15/31 13/32
vt 0.146 0.004
vt 0.075 0.924
vt 0.185 0.893
f 14/33 17/34 15/35
vt 0.103 0.131
vt 0.103 0.924
vt 0.075 0.924
f 16/36 18/37 17/38
vt 0.338 0.988
vt 0.360 0.194
vt 0.359 0.988
f 19/39 20/40 21/41
vt 0.435 0.988
vt 0.312 -0.004
vt 0.338 0.988
f 22/42 23/43 19/44
vt 0.408 0.988
vt 0.312 -0.004
vt 0.435 0.988
f 24/45 23/46 22/47
vt 0.386 0.996
vt 0.383 0.194
vt 0.408 0.988
f 25/48 26/49 24/50
vt 0.359 0.988
vt 0.383 0.194
vt 0.386 0.996
f 21/51 26/52 25/53
vt 0.339 0.060
vt 0.360 0.194
vt 0.338 0.988
f 27/54 20/55 19/56
vt 0.338 0.988
vt 0.312 -0.004
vt 0.339 0.060
f 19/57 23/58 27/59
vt 0.408 0.060
vt 0.312 -0.004
vt 0.408 0.988
f 28/60 23/61 24/62
vt 0.408 0.988
vt 0.383 0.194
vt 0.408 0.060
f 24/63 26/64 28/65
vt 0.360 0.194
vt 0.383 0.194
vt 0.359 0.988
f 20/66 26/67 21/68
vt 0.082 0.988
vt 0.095 0.496
vt 0.096 0.996
f 29/69 30/70 31/71
vt 0.072 0.988
vt 0.072 0.496
vt 0.082 0.988
f 32/72 33/73 29/74
vt 0.122 0.988
vt 0.122 0.496
vt 0.072 0.988
f 34/75 35/76 32/77
vt 0.109 0.988
vt 0.122 0.496
vt 0.122 0.988
f 36/78 35/79 34/80
vt 0.096 0.996
vt 0.095 0.496
vt 0.109 0.988
f 31/81 30/82 36/83
vt 0.083 0.496
vt 0.095 0.496
vt 0.082 0.988
f 37/84 30/85 29/86
vt 0.082 0.988
vt 0.072 0.496
vt 0.083 0.496
f 29/87 33/88 37/89
vt 0.072 0.988
vt 0.122 0.496
vt 0.072 0.496
f 32/90 35/91 33/92
vt 0.109 0.496
vt 0.122 0.496
vt 0.109 0.988
f 38/93 35/94 36/95
vt 0.109 0.988
vt 0.095 0.496
vt 0.109 0.496
f 36/96 30/97 38/98
vt 0.813 0.742
vt 0.836 0.504
vt 0.873 0.591
vt 0.873 0.885
vt 0.836 0.980
f 39/99 40/100 41/101 42/102 43/103
vt 0.814 0.742
vt 0.836 0.512
vt 0.872 0.599
vt 0.872 0.885
vt 0.836 0.972
f 44/104 45/105 46/106 47/107 48/108
vt 0.082 0.496
vt 0.096 0.496
vt 0.096 0.996
vt 0.082 0.988
f 49/109 50/110 51/111 52/112
vt 0.073 0.496
vt 0.082 0.496
vt 0.082 0.988
vt 0.072 0.988
f 53/113 49/114 52/115 54/116
vt 0.122 0.496
vt 0.073 0.496
vt 0.072 0.988
vt 0.122 0.988
f 55/117 53/118 54/119 56/120
vt 0.109 0.496
vt 0.122 0.496
vt 0.122 0.988
vt 0.109 0.988
f 57/121 55/122 56/123 58/124
vt 0.096 0.496
vt 0.109 0.496
vt 0.109 0.988
vt 0.096 0.996
f 50/125 57/126 58/127 51/128
vt 0.086 0.607
vt 0.116 0.726
vt 0.081 0.837
f 59/129 60/130 61/131
vt 0.081 0.837
vt 0.116 0.726
vt 0.107 0.909
f 61/132 60/133 62/134
vt 0.116 0.726
vt 0.086 0.607
vt 0.107 0.559
f 60/135 59/136 63/137
vt 0.451 0.996
vt 0.437 0.694
vt 0.467 0.496
vt 0.499 0.663
vt 0.490 0.972
f 64/138 65/139 66/140 67/141 68/142
vt 0.073 0.718
vt 0.115 0.686
vt 0.093 0.552
f 69/143 70/144 71/145
vt 0.073 0.718
vt 0.083 0.956
vt 0.109 0.940
vt 0.115 0.686
f 69/146 72/147 73/148 70/149
vt 0.312 0.496
vt 0.374 0.694
vt 0.312 0.996
f 74/150 75/151 76/152
vt 0.312 0.893
vt 0.312 0.694
vt 0.374 0.996
f 77/153 78/154 79/155
vt 0.312 0.996
vt 0.374 0.694
vt 0.374 0.893
f 76/156 75/157 80/158
vt 0.374 0.996
vt 0.312 0.694
vt 0.374 0.496
f 79/159 78/160 5/161
vt 0.357 0.694
vt 0.351 0.893
vt 0.335 0.893
vt 0.329 0.694
f 81/162 82/163 83/164 84/165
vt 0.077 0.996
vt 0.062 0.496
vt 0.124 0.496
vt 0.109 0.996
f 85/166 86/167 87/168 88/169
`;

export const rightArmOBJ = `v 437.000 391.000 -41.000
v 437.000 391.000 3.000
v 254.000 424.000 25.000
v 254.000 424.000 -62.000
v 254.000 260.000 -105.000
v 254.000 260.000 67.000
v 437.000 326.000 18.000
v 437.000 326.000 -56.000
v 298.000 276.000 40.000
v 365.000 300.000 20.000
v 439.000 101.000 71.000
v 407.000 315.000 -19.000
v 533.000 124.000 85.000
v 364.000 299.000 -57.000
v 563.000 67.000 46.000
v 297.000 275.000 -76.000
v 531.000 14.000 14.000
v 466.000 30.000 24.000
v 437.000 391.000 3.000
v 437.000 326.000 18.000
v 254.000 424.000 25.000
v 254.000 260.000 -105.000
v 437.000 326.000 -56.000
v 254.000 424.000 -62.000
v 254.000 260.000 67.000
v 437.000 391.000 -41.000
v 437.000 326.000 -56.000
v 437.000 326.000 18.000
v 437.000 391.000 3.000
v 437.000 391.000 -41.000
v 254.000 424.000 -62.000
v 254.000 424.000 25.000
v 254.000 260.000 67.000
v 254.000 260.000 -105.000
v 533.000 124.000 85.000
v 531.000 14.000 14.000
v 439.000 101.000 71.000
v 563.000 67.000 46.000
v 466.000 30.000 24.000
v 453.000 136.000 92.000
v 487.000 12.000 15.000
v 538.000 131.000 92.000
v 383.000 56.000 399.000
v 430.000 148.000 400.000
v 558.000 142.000 400.000
v 590.000 47.000 398.000
v 482.000 -6.000 398.000
v 560.000 55.000 41.000
v 421.000 63.000 41.000
v 538.000 131.000 92.000
v 590.000 47.000 398.000
v 558.000 142.000 400.000
v 560.000 55.000 41.000
v 487.000 12.000 15.000
v 383.000 56.000 399.000
v 482.000 -6.000 398.000
v 421.000 63.000 41.000
v 453.000 136.000 92.000
v 504.000 125.000 399.000
v 553.000 87.000 530.000
v 507.000 99.000 530.000
v 573.000 104.000 399.000
v 573.000 37.000 398.000
v 504.000 17.000 398.000
v 553.000 50.000 530.000
v 479.000 69.000 530.000
v 507.000 39.000 529.000
v 461.000 71.000 398.000
v 507.000 39.000 529.000
v 479.000 69.000 530.000
v 507.000 99.000 530.000
v 553.000 87.000 530.000
v 553.000 50.000 530.000
v 417.000 38.000 496.000
v 391.000 65.000 496.000
v 417.000 92.000 497.000
v 459.000 82.000 496.000
v 459.000 48.000 496.000
v 459.000 83.000 401.000
v 459.000 82.000 496.000
v 417.000 92.000 497.000
v 417.000 94.000 402.000
v 459.000 49.000 401.000
v 459.000 48.000 496.000
v 417.000 39.000 401.000
v 417.000 38.000 496.000
v 391.000 66.000 401.000
v 391.000 65.000 496.000
vt 0.368 0.282
vt 0.371 0.282
vt 0.373 0.329
vt 0.362 0.345
f 1/1 2/2 3/3 4/4
vt 0.353 0.194
vt 0.374 0.163
vt 0.372 0.210
vt 0.365 0.226
f 5/5 6/6 7/7 8/8
vt 0.144 0.932
vt 0.111 0.901
vt 0.131 0.329
f 9/9 10/10 11/11
vt 0.111 0.901
vt 0.085 0.877
vt 0.110 0.258
f 10/12 12/13 13/14
vt 0.085 0.877
vt 0.065 0.901
vt 0.104 0.083
f 12/15 14/16 15/17
vt 0.065 0.901
vt 0.174 0.932
vt 0.106 0.004
f 14/18 16/19 17/20
vt 0.174 0.932
vt 0.144 0.932
vt 0.145 0.131
f 16/21 9/22 18/23
vt 0.131 0.329
vt 0.111 0.901
vt 0.110 0.258
f 11/24 10/25 13/26
vt 0.110 0.258
vt 0.085 0.877
vt 0.104 0.083
f 13/27 12/28 15/29
vt 0.104 0.083
vt 0.065 0.901
vt 0.106 0.004
f 15/30 14/31 17/32
vt 0.106 0.004
vt 0.174 0.932
vt 0.145 0.131
f 17/33 16/34 18/35
vt 0.145 0.131
vt 0.144 0.932
vt 0.131 0.329
f 18/36 9/37 11/38
vt 0.312 0.893
vt 0.312 0.694
vt 0.374 0.996
f 19/39 20/40 21/41
vt 0.312 0.496
vt 0.374 0.694
vt 0.312 0.996
f 22/42 23/43 24/44
vt 0.374 0.996
vt 0.312 0.694
vt 0.374 0.496
f 21/45 20/46 25/47
vt 0.312 0.996
vt 0.374 0.694
vt 0.374 0.893
f 24/48 23/49 26/50
vt 0.329 0.694
vt 0.357 0.694
vt 0.351 0.893
vt 0.335 0.893
f 27/51 28/52 29/53 30/54
vt 0.109 0.996
vt 0.077 0.996
vt 0.062 0.496
vt 0.124 0.496
f 31/55 32/56 33/57 34/58
vt 0.079 0.909
vt 0.079 0.559
vt 0.107 0.837
f 35/59 36/60 37/61
vt 0.079 0.559
vt 0.079 0.909
vt 0.070 0.726
f 36/62 35/63 38/64
vt 0.107 0.837
vt 0.079 0.559
vt 0.099 0.607
f 37/65 36/66 39/67
vt 0.103 0.956
vt 0.093 0.552
vt 0.077 0.940
f 40/68 41/69 42/70
vt 0.249 0.694
vt 0.235 0.996
vt 0.196 0.972
vt 0.187 0.663
vt 0.219 0.496
f 43/71 44/72 45/73 46/74 47/75
vt 0.077 0.940
vt 0.093 0.552
vt 0.071 0.686
f 42/76 41/77 48/78
vt 0.093 0.552
vt 0.103 0.956
vt 0.113 0.718
f 41/79 40/80 49/81
vt 0.388 0.194
vt 0.410 0.988
vt 0.389 0.988
f 50/82 51/83 52/84
vt 0.409 0.060
vt 0.436 -0.004
vt 0.410 0.988
f 53/85 54/86 51/87
vt 0.436 -0.004
vt 0.340 0.988
vt 0.313 0.988
f 54/88 55/89 56/90
vt 0.340 0.060
vt 0.365 0.194
vt 0.340 0.988
f 57/91 58/92 55/93
vt 0.365 0.194
vt 0.389 0.988
vt 0.360 0.996
f 58/94 52/95 44/96
vt 0.388 0.194
vt 0.409 0.060
vt 0.410 0.988
f 50/97 53/98 51/99
vt 0.410 0.988
vt 0.436 -0.004
vt 0.313 0.988
f 51/100 54/101 56/102
vt 0.436 -0.004
vt 0.340 0.060
vt 0.340 0.988
f 54/103 57/104 55/105
vt 0.340 0.988
vt 0.365 0.194
vt 0.360 0.996
f 55/106 58/107 44/108
vt 0.365 0.194
vt 0.388 0.194
vt 0.389 0.988
f 58/109 50/110 52/111
vt 0.091 0.496
vt 0.104 0.988
vt 0.090 0.996
f 59/112 60/113 61/114
vt 0.103 0.496
vt 0.114 0.496
vt 0.104 0.988
f 62/115 63/116 60/117
vt 0.114 0.496
vt 0.064 0.496
vt 0.114 0.988
f 63/118 64/119 65/120
vt 0.064 0.496
vt 0.077 0.988
vt 0.064 0.988
f 64/121 66/122 67/123
vt 0.077 0.496
vt 0.091 0.496
vt 0.077 0.988
f 68/124 59/125 66/126
vt 0.091 0.496
vt 0.103 0.496
vt 0.104 0.988
f 59/127 62/128 60/129
vt 0.104 0.988
vt 0.114 0.496
vt 0.114 0.988
f 60/130 63/131 65/132
vt 0.114 0.988
vt 0.064 0.496
vt 0.064 0.988
f 65/133 64/134 67/135
vt 0.064 0.496
vt 0.077 0.496
vt 0.077 0.988
f 64/136 68/137 66/138
vt 0.077 0.988
vt 0.091 0.496
vt 0.090 0.996
f 66/139 59/140 61/141
vt 0.850 0.520
vt 0.871 0.742
vt 0.850 0.964
vt 0.815 0.877
vt 0.815 0.607
f 69/142 70/143 71/144 72/145 73/146
vt 0.850 0.504
vt 0.873 0.742
vt 0.850 0.980
vt 0.813 0.893
vt 0.813 0.591
f 74/147 75/148 76/149 77/150 78/151
vt 0.104 0.496
vt 0.104 0.988
vt 0.090 0.996
vt 0.090 0.496
f 79/152 80/153 81/154 82/155
vt 0.113 0.496
vt 0.114 0.988
vt 0.104 0.988
vt 0.104 0.496
f 83/156 84/157 80/158 79/159
vt 0.064 0.496
vt 0.064 0.988
vt 0.114 0.988
vt 0.113 0.496
f 85/160 86/161 84/162 83/163
vt 0.077 0.496
vt 0.077 0.988
vt 0.064 0.988
vt 0.064 0.496
f 87/164 88/165 86/166 85/167
vt 0.090 0.496
vt 0.090 0.996
vt 0.077 0.988
vt 0.077 0.496
f 82/168 81/169 88/170 87/171
`;

export const leftUpperLegOBJ = `v -342.000 -346.000 57.000
v -128.000 -346.000 57.000
v -128.000 -346.000 -73.000
v -342.000 -346.000 -73.000
v -342.000 -8.000 -62.000
v -128.000 25.000 -62.000
v -128.000 25.000 70.000
v -342.000 -8.000 70.000
v -342.000 -74.000 -128.000
v -342.000 -346.000 -73.000
v -128.000 -41.000 -128.000
v -342.000 -214.000 114.000
v -128.000 25.000 70.000
v -128.000 -214.000 114.000
v -128.000 -346.000 -73.000
v -128.000 -346.000 57.000
v -342.000 -346.000 57.000
v -342.000 -8.000 70.000
v -128.000 25.000 -62.000
v -342.000 -8.000 -62.000
v -128.000 25.000 70.000
v -128.000 25.000 -62.000
v -128.000 -41.000 -128.000
v -128.000 -346.000 -73.000
v -128.000 -346.000 57.000
v -128.000 -214.000 114.000
v -342.000 -74.000 -128.000
v -342.000 -8.000 -62.000
v -342.000 -8.000 70.000
v -342.000 -214.000 114.000
v -342.000 -346.000 57.000
v -342.000 -346.000 -73.000
vt 0.062 0.948
vt 0.124 0.948
vt 0.124 0.496
vt 0.062 0.496
f 1/1 2/2 3/3 4/4
vt 0.437 0.528
vt 0.499 0.528
vt 0.499 0.996
vt 0.437 0.996
f 5/5 6/6 7/7 8/8
vt 0.312 0.726
vt 0.312 -0.004
vt 0.374 0.813
f 9/9 10/10 11/11
vt 0.374 0.345
vt 0.312 0.996
vt 0.312 0.345
f 12/12 13/13 14/14
vt 0.374 0.813
vt 0.312 -0.004
vt 0.374 -0.004
f 11/15 10/16 15/17
vt 0.374 0.345
vt 0.312 0.345
vt 0.312 -0.004
vt 0.374 -0.004
f 12/18 14/19 16/20 17/21
vt 0.374 0.345
vt 0.374 0.901
vt 0.312 0.996
f 12/22 18/23 13/24
vt 0.312 0.726
vt 0.374 0.813
vt 0.374 0.996
vt 0.312 0.901
f 9/25 11/26 19/27 20/28
vt 0.738 0.996
vt 0.704 0.996
vt 0.687 0.813
vt 0.701 -0.004
vt 0.735 -0.004
vt 0.749 0.345
f 21/29 22/30 23/31 24/32 25/33 26/34
vt 0.374 0.726
vt 0.357 0.901
vt 0.323 0.901
vt 0.312 0.345
vt 0.326 -0.004
vt 0.360 -0.004
f 27/35 28/36 29/37 30/38 31/39 32/40
`;

export const rightUpperLegOBJ = `v 128.000 -346.000 -73.000
v 342.000 -346.000 -73.000
v 128.000 -41.000 -128.000
v 128.000 25.000 70.000
v 342.000 -214.000 114.000
v 128.000 -214.000 114.000
v 342.000 -74.000 -128.000
v 342.000 -346.000 57.000
v 128.000 -346.000 57.000
v 342.000 -8.000 70.000
v 342.000 -8.000 -62.000
v 128.000 25.000 -62.000
v 342.000 -346.000 57.000
v 342.000 -346.000 -73.000
v 128.000 -346.000 -73.000
v 128.000 -346.000 57.000
v 342.000 -8.000 -62.000
v 342.000 -8.000 70.000
v 128.000 25.000 70.000
v 128.000 25.000 -62.000
v 128.000 -41.000 -128.000
v 128.000 25.000 -62.000
v 128.000 25.000 70.000
v 128.000 -214.000 114.000
v 128.000 -346.000 57.000
v 128.000 -346.000 -73.000
v 342.000 -8.000 70.000
v 342.000 -8.000 -62.000
v 342.000 -74.000 -128.000
v 342.000 -346.000 -73.000
v 342.000 -346.000 57.000
v 342.000 -214.000 114.000
vt 0.312 -0.004
vt 0.374 -0.004
vt 0.312 0.813
f 1/1 2/2 3/3
vt 0.374 0.996
vt 0.312 0.345
vt 0.374 0.345
f 4/4 5/5 6/6
vt 0.312 0.813
vt 0.374 -0.004
vt 0.374 0.726
f 3/7 2/8 7/9
vt 0.312 0.345
vt 0.312 -0.004
vt 0.374 -0.004
vt 0.374 0.345
f 5/10 8/11 9/12 6/13
vt 0.312 0.901
vt 0.312 0.345
vt 0.374 0.996
f 10/14 5/15 4/16
vt 0.374 0.726
vt 0.374 0.901
vt 0.312 0.996
vt 0.312 0.813
f 7/17 11/18 12/19 3/20
vt 0.124 0.948
vt 0.124 0.496
vt 0.062 0.496
vt 0.062 0.948
f 13/21 14/22 15/23 16/24
vt 0.499 0.528
vt 0.499 0.996
vt 0.437 0.996
vt 0.437 0.528
f 17/25 18/26 19/27 20/28
vt 0.749 0.813
vt 0.732 0.996
vt 0.698 0.996
vt 0.687 0.345
vt 0.701 -0.004
vt 0.735 -0.004
f 21/29 22/30 23/31 24/32 25/33 26/34
vt 0.363 0.901
vt 0.329 0.901
vt 0.312 0.726
vt 0.326 -0.004
vt 0.360 -0.004
vt 0.374 0.345
f 27/35 28/36 29/37 30/38 31/39 32/40
`;

export const leftLowerLegOBJ = `v -341.000 -732.000 -80.000
v -127.000 -732.000 -80.000
v -127.000 -412.000 -98.000
v -341.000 -412.000 -98.000
v -341.000 -477.000 132.000
v -127.000 -477.000 132.000
v -127.000 -732.000 117.000
v -341.000 -732.000 117.000
v -299.000 -379.000 165.000
v -170.000 -379.000 165.000
v -127.000 -346.000 -66.000
v -341.000 -346.000 -66.000
v -341.000 -732.000 117.000
v -127.000 -732.000 117.000
v -127.000 -732.000 -80.000
v -341.000 -732.000 -80.000
v -341.000 -379.000 100.000
v -127.000 -379.000 100.000
v -170.000 -379.000 165.000
v -299.000 -379.000 165.000
v -341.000 -346.000 57.000
v -127.000 -346.000 57.000
v -341.000 -346.000 -66.000
v -127.000 -346.000 -66.000
v -341.000 -477.000 132.000
v -341.000 -379.000 100.000
v -299.000 -379.000 165.000
v -170.000 -379.000 165.000
v -127.000 -379.000 100.000
v -127.000 -477.000 132.000
v -127.000 -346.000 57.000
v -127.000 -346.000 -66.000
v -127.000 -412.000 -98.000
v -127.000 -732.000 -80.000
v -127.000 -732.000 117.000
v -341.000 -346.000 57.000
v -341.000 -732.000 117.000
v -341.000 -732.000 -80.000
v -341.000 -412.000 -98.000
v -341.000 -346.000 -66.000
vt 0.312 -0.004
vt 0.374 -0.004
vt 0.374 0.821
vt 0.312 0.821
f 1/1 2/2 3/3 4/4
vt 0.374 0.655
vt 0.312 0.655
vt 0.312 -0.004
vt 0.374 -0.004
f 5/5 6/6 7/7 8/8
vt 0.112 0.909
vt 0.074 0.909
vt 0.062 0.655
vt 0.124 0.655
f 9/9 10/10 6/11 5/12
vt 0.312 0.821
vt 0.374 0.821
vt 0.374 0.996
vt 0.312 0.996
f 4/13 3/14 11/15 12/16
vt 0.062 0.893
vt 0.124 0.893
vt 0.124 0.496
vt 0.062 0.496
f 13/17 14/18 15/19 16/20
vt 0.062 0.861
vt 0.124 0.861
vt 0.112 0.996
vt 0.074 0.996
f 17/21 18/22 19/23 20/24
vt 0.062 0.774
vt 0.124 0.774
vt 0.124 0.861
vt 0.062 0.861
f 21/25 22/26 18/27 17/28
vt 0.062 0.520
vt 0.124 0.520
vt 0.124 0.774
vt 0.062 0.774
f 23/29 24/30 22/31 21/32
vt 0.069 0.655
vt 0.077 0.909
vt 0.062 0.909
f 25/33 26/34 27/35
vt 0.124 0.909
vt 0.109 0.909
vt 0.117 0.655
f 28/36 29/37 30/38
vt 0.724 0.996
vt 0.694 0.996
vt 0.687 0.821
vt 0.691 -0.004
vt 0.738 -0.004
vt 0.742 0.655
vt 0.734 0.909
f 31/39 32/40 33/41 34/42 35/43 30/44 29/45
vt 0.337 0.996
vt 0.327 0.909
vt 0.319 0.655
vt 0.323 -0.004
vt 0.370 -0.004
vt 0.374 0.821
vt 0.367 0.996
f 36/46 26/47 25/48 37/49 38/50 39/51 40/52
`;

export const rightLowerLegOBJ = `v 341.000 -732.000 -69.000
v 341.000 -412.000 -87.000
v 127.000 -412.000 -87.000
v 127.000 -732.000 -69.000
v 341.000 -477.000 143.000
v 341.000 -732.000 128.000
v 127.000 -732.000 128.000
v 127.000 -477.000 143.000
v 299.000 -379.000 176.000
v 170.000 -379.000 176.000
v 341.000 -346.000 -55.000
v 127.000 -346.000 -55.000
v 341.000 -732.000 128.000
v 341.000 -732.000 -69.000
v 127.000 -732.000 -69.000
v 127.000 -732.000 128.000
v 341.000 -379.000 111.000
v 299.000 -379.000 176.000
v 170.000 -379.000 176.000
v 127.000 -379.000 111.000
v 341.000 -346.000 68.000
v 127.000 -346.000 68.000
v 341.000 -346.000 -55.000
v 127.000 -346.000 -55.000
v 127.000 -477.000 143.000
v 127.000 -379.000 111.000
v 170.000 -379.000 176.000
v 299.000 -379.000 176.000
v 341.000 -379.000 111.000
v 341.000 -477.000 143.000
v 127.000 -346.000 68.000
v 127.000 -732.000 128.000
v 127.000 -732.000 -69.000
v 127.000 -412.000 -87.000
v 127.000 -346.000 -55.000
v 341.000 -346.000 68.000
v 341.000 -346.000 -55.000
v 341.000 -412.000 -87.000
v 341.000 -732.000 -69.000
v 341.000 -732.000 128.000
vt 0.374 -0.004
vt 0.374 0.821
vt 0.312 0.821
vt 0.312 -0.004
f 1/1 2/2 3/3 4/4
vt 0.312 0.655
vt 0.312 -0.004
vt 0.374 -0.004
vt 0.374 0.655
f 5/5 6/6 7/7 8/8
vt 0.074 0.909
vt 0.062 0.655
vt 0.124 0.655
vt 0.112 0.909
f 9/9 5/10 8/11 10/12
vt 0.374 0.821
vt 0.374 0.996
vt 0.312 0.996
vt 0.312 0.821
f 2/13 11/14 12/15 3/16
vt 0.124 0.893
vt 0.124 0.496
vt 0.062 0.496
vt 0.062 0.893
f 13/17 14/18 15/19 16/20
vt 0.124 0.861
vt 0.112 0.996
vt 0.074 0.996
vt 0.062 0.861
f 17/21 18/22 19/23 20/24
vt 0.124 0.774
vt 0.124 0.861
vt 0.062 0.861
vt 0.062 0.774
f 21/25 17/26 20/27 22/28
vt 0.124 0.520
vt 0.124 0.774
vt 0.062 0.774
vt 0.062 0.520
f 23/29 21/30 22/31 24/32
vt 0.069 0.655
vt 0.077 0.909
vt 0.062 0.909
f 25/33 26/34 27/35
vt 0.124 0.909
vt 0.109 0.909
vt 0.117 0.655
f 28/36 29/37 30/38
vt 0.712 0.996
vt 0.702 0.909
vt 0.694 0.655
vt 0.698 -0.004
vt 0.745 -0.004
vt 0.749 0.821
vt 0.742 0.996
f 31/39 26/40 25/41 32/42 33/43 34/44 35/45
vt 0.349 0.996
vt 0.319 0.996
vt 0.312 0.821
vt 0.316 -0.004
vt 0.363 -0.004
vt 0.367 0.655
vt 0.359 0.909
f 36/46 37/47 38/48 39/49 40/50 30/51 29/52
`;

export const leftFootOBJ = `v -127.000 -732.000 115.000
v -127.000 -831.000 115.000
v -165.000 -765.000 313.000
v -341.000 -831.000 115.000
v -341.000 -732.000 115.000
v -341.000 -831.000 357.000
v -127.000 -831.000 357.000
v -304.000 -765.000 313.000
vt 0.086 0.472
vt 0.093 0.480
vt 0.115 0.671
f 1/1 2/2 3/3
vt 0.069 0.726
vt 0.062 0.718
vt 0.108 0.924
f 4/4 5/5 6/6
vt 0.115 0.671
vt 0.093 0.480
vt 0.130 0.671
f 3/7 2/8 7/9
vt 0.108 0.924
vt 0.062 0.718
vt 0.100 0.837
f 6/10 5/11 8/12
vt 0.069 0.726
vt 0.108 0.924
vt 0.130 0.671
vt 0.093 0.480
f 4/13 6/14 7/15 2/16
vt 0.100 0.837
vt 0.062 0.718
vt 0.086 0.472
vt 0.115 0.671
f 8/17 5/18 1/19 3/20
vt 0.100 0.837
vt 0.115 0.671
vt 0.130 0.671
vt 0.108 0.924
f 8/21 3/22 7/23 6/24
vt 0.093 0.480
vt 0.086 0.472
vt 0.062 0.718
vt 0.069 0.726
f 2/25 1/26 5/27 4/28
`;

export const rightFootOBJ = `v 341.000 -732.000 115.000
v 341.000 -831.000 115.000
v 304.000 -765.000 313.000
v 127.000 -831.000 115.000
v 127.000 -732.000 115.000
v 127.000 -831.000 357.000
v 341.000 -831.000 357.000
v 165.000 -765.000 313.000
vt 0.137 0.417
vt 0.145 0.425
vt 0.167 0.623
f 1/1 2/2 3/3
vt 0.122 0.671
vt 0.115 0.671
vt 0.159 0.869
f 4/4 5/5 6/6
vt 0.167 0.623
vt 0.145 0.425
vt 0.183 0.615
f 3/7 2/8 7/9
vt 0.159 0.869
vt 0.115 0.671
vt 0.151 0.782
f 6/10 5/11 8/12
vt 0.122 0.671
vt 0.159 0.869
vt 0.183 0.615
vt 0.145 0.425
f 4/13 6/14 7/15 2/16
vt 0.151 0.782
vt 0.115 0.671
vt 0.137 0.417
vt 0.167 0.623
f 8/17 5/18 1/19 3/20
vt 0.151 0.782
vt 0.167 0.623
vt 0.183 0.615
vt 0.159 0.869
f 8/21 3/22 7/23 6/24
vt 0.122 0.671
vt 0.145 0.425
vt 0.137 0.417
vt 0.115 0.671
f 4/25 2/26 1/27 5/28
`;

// Locust Light Mech OBJ Data (20 tons - smallest, fastest)
export const locustBodyOBJ = `v 80.000 200.000 -60.000
v 120.000 150.000 -80.000
v 120.000 180.000 -40.000
v -120.000 180.000 -40.000
v -120.000 150.000 -80.000
v -80.000 200.000 -60.000
v 80.000 50.000 -90.000
v 120.000 20.000 -50.000
v -120.000 20.000 -50.000
v -80.000 50.000 -90.000
v 60.000 30.000 40.000
v 90.000 60.000 90.000
v 120.000 20.000 50.000
v -120.000 20.000 50.000
v -90.000 60.000 90.000
v -60.000 30.000 40.000
v 40.000 50.000 120.000
v 40.000 120.000 110.000
v -90.000 100.000 90.000
v -40.000 50.000 120.000
v 90.000 140.000 60.000
v 90.000 100.000 90.000
v -90.000 140.000 60.000
v -40.000 120.000 110.000
v 40.000 160.000 80.000
v 60.000 200.000 40.000
v -60.000 200.000 40.000
v -40.000 160.000 80.000
vt 0.288 0.694
vt 0.312 0.464
vt 0.312 0.647
f 1/1 2/2 3/3
vt 0.187 0.647
vt 0.187 0.464
vt 0.210 0.694
f 4/4 5/5 6/6
vt 0.288 0.464
vt 0.312 0.052
vt 0.312 0.464
f 7/7 8/8 2/9
vt 0.187 0.464
vt 0.187 0.052
vt 0.210 0.464
f 5/10 9/11 10/12
vt 0.333 0.036
vt 0.318 0.163
vt 0.312 0.052
f 11/13 12/14 13/15
vt 0.437 0.052
vt 0.430 0.163
vt 0.415 0.036
f 14/16 15/17 16/18
vt 0.348 0.155
vt 0.349 0.409
vt 0.318 0.163
f 17/19 18/20 12/21
vt 0.430 0.163
vt 0.430 0.377
vt 0.400 0.155
f 15/22 19/23 20/24
vt 0.349 0.409
vt 0.318 0.528
vt 0.318 0.377
f 18/25 21/26 22/27
vt 0.430 0.377
vt 0.430 0.528
vt 0.399 0.409
f 19/28 23/29 24/30
vt 0.349 0.607
vt 0.335 0.694
vt 0.318 0.528
f 25/31 26/32 21/33
vt 0.430 0.528
vt 0.413 0.694
vt 0.399 0.607
f 23/34 27/35 28/36
`;

export const locustLeftArmOBJ = `v -120.000 140.000 -20.000
v -90.000 150.000 -30.000
v -90.000 150.000 10.000
v -120.000 140.000 5.000
v -90.000 80.000 -40.000
v -120.000 100.000 -25.000
v -120.000 100.000 8.000
v -90.000 80.000 25.000
vt 0.312 0.678
vt 0.374 0.615
vt 0.374 0.869
vt 0.312 0.805
f 1/1 2/2 3/3 4/4
vt 0.249 0.496
vt 0.187 0.631
vt 0.187 0.853
vt 0.249 0.996
f 5/5 6/6 7/7 8/8
vt 0.312 0.496
vt 0.374 0.694
vt 0.312 0.996
f 1/1 6/6 7/7
vt 0.374 0.996
vt 0.312 0.694
vt 0.374 0.496
f 3/3 2/2 8/8
`;

export const locustRightArmOBJ = `v 120.000 140.000 -20.000
v 120.000 140.000 5.000
v 90.000 150.000 10.000
v 90.000 150.000 -30.000
v 90.000 80.000 -40.000
v 90.000 80.000 25.000
v 120.000 100.000 8.000
v 120.000 100.000 -25.000
vt 0.368 0.282
vt 0.371 0.282
vt 0.373 0.329
vt 0.362 0.345
f 1/1 2/2 3/3 4/4
vt 0.353 0.194
vt 0.374 0.163
vt 0.372 0.210
vt 0.365 0.226
f 5/5 6/6 7/7 8/8
vt 0.312 0.893
vt 0.312 0.694
vt 0.374 0.996
f 1/1 8/8 7/7
vt 0.374 0.996
vt 0.312 0.694
vt 0.374 0.496
f 3/3 6/6 5/5
`;

export const locustLeftLegOBJ = `v -60.000 -20.000 30.000
v -60.000 -50.000 30.000
v -80.000 -40.000 80.000
v -120.000 -50.000 30.000
v -120.000 -20.000 30.000
v -120.000 -50.000 120.000
v -60.000 -50.000 120.000
v -100.000 -40.000 80.000
vt 0.086 0.472
vt 0.093 0.480
vt 0.115 0.671
f 1/1 2/2 3/3
vt 0.069 0.726
vt 0.062 0.718
vt 0.108 0.924
f 4/4 5/5 6/6
vt 0.115 0.671
vt 0.093 0.480
vt 0.130 0.671
f 3/7 2/8 7/9
vt 0.108 0.924
vt 0.062 0.718
vt 0.100 0.837
f 6/10 5/11 8/12
`;

export const locustRightLegOBJ = `v 60.000 -20.000 30.000
v 60.000 -50.000 30.000
v 100.000 -40.000 80.000
v 120.000 -50.000 30.000
v 120.000 -20.000 30.000
v 120.000 -50.000 120.000
v 60.000 -50.000 120.000
v 80.000 -40.000 80.000
vt 0.137 0.417
vt 0.145 0.425
vt 0.167 0.623
f 1/1 2/2 3/3
vt 0.122 0.671
vt 0.115 0.671
vt 0.159 0.869
f 4/4 5/5 6/6
vt 0.167 0.623
vt 0.145 0.425
vt 0.183 0.615
f 3/7 2/8 7/9
vt 0.159 0.869
vt 0.115 0.671
vt 0.151 0.782
f 6/10 5/11 8/12
`;

// Jenner Light Mech OBJ Data (35 tons - balanced fighter)
export const jennerBodyOBJ = `v 100.000 250.000 -80.000
v 140.000 200.000 -100.000
v 140.000 220.000 -60.000
v -140.000 220.000 -60.000
v -140.000 200.000 -100.000
v -100.000 250.000 -80.000
v 100.000 70.000 -110.000
v 140.000 30.000 -70.000
v -140.000 30.000 -70.000
v -100.000 70.000 -110.000
v 80.000 40.000 60.000
v 110.000 80.000 110.000
v 140.000 30.000 70.000
v -140.000 30.000 70.000
v -110.000 80.000 110.000
v -80.000 40.000 60.000
v 60.000 70.000 140.000
v 60.000 140.000 130.000
v -110.000 120.000 110.000
v -60.000 70.000 140.000
v 110.000 160.000 80.000
v 110.000 120.000 110.000
v -110.000 160.000 80.000
v -60.000 140.000 130.000
v 60.000 180.000 100.000
v 80.000 220.000 60.000
v -80.000 220.000 60.000
v -60.000 180.000 100.000
v 120.000 60.000 -120.000
v -120.000 60.000 -120.000
v 140.000 220.000 30.000
v -140.000 220.000 30.000
vt 0.288 0.694
vt 0.312 0.464
vt 0.312 0.647
f 1/1 2/2 3/3
vt 0.187 0.647
vt 0.187 0.464
vt 0.210 0.694
f 4/4 5/5 6/6
vt 0.288 0.464
vt 0.312 0.052
vt 0.312 0.464
f 7/7 8/8 2/9
vt 0.187 0.464
vt 0.187 0.052
vt 0.210 0.464
f 5/10 9/11 10/12
vt 0.333 0.036
vt 0.318 0.163
vt 0.312 0.052
f 11/13 12/14 13/15
vt 0.437 0.052
vt 0.430 0.163
vt 0.415 0.036
f 14/16 15/17 16/18
vt 0.348 0.155
vt 0.349 0.409
vt 0.318 0.163
f 17/19 18/20 12/21
vt 0.430 0.163
vt 0.430 0.377
vt 0.400 0.155
f 15/22 19/23 20/24
vt 0.349 0.409
vt 0.318 0.528
vt 0.318 0.377
f 18/25 21/26 22/27
vt 0.430 0.377
vt 0.430 0.528
vt 0.399 0.409
f 19/28 23/29 24/30
vt 0.349 0.607
vt 0.335 0.694
vt 0.318 0.528
f 25/31 26/32 21/33
vt 0.430 0.528
vt 0.413 0.694
vt 0.399 0.607
f 23/34 27/35 28/36
vt 0.290 0.036
vt 0.312 0.052
vt 0.288 0.464
f 29/37 8/38 7/39
vt 0.208 0.036
vt 0.290 0.036
vt 0.288 0.464
vt 0.210 0.464
f 30/40 29/41 7/42 10/43
vt 0.318 0.528
vt 0.335 0.694
vt 0.312 0.647
f 21/44 26/45 31/46
vt 0.437 0.647
vt 0.413 0.694
vt 0.430 0.528
f 32/47 27/48 23/49
`;

export const jennerLeftArmOBJ = `v -140.000 180.000 -30.000
v -110.000 190.000 -40.000
v -110.000 190.000 15.000
v -140.000 180.000 8.000
v -110.000 100.000 -50.000
v -140.000 120.000 -35.000
v -140.000 120.000 12.000
v -110.000 100.000 30.000
v -180.000 50.000 20.000
v -120.000 80.000 5.000
v -150.000 40.000 25.000
v -190.000 30.000 15.000
v -130.000 90.000 -15.000
v -170.000 10.000 5.000
v -120.000 85.000 -20.000
v -155.000 15.000 8.000
vt 0.312 0.678
vt 0.374 0.615
vt 0.374 0.869
vt 0.312 0.805
f 1/1 2/2 3/3 4/4
vt 0.249 0.496
vt 0.187 0.631
vt 0.187 0.853
vt 0.249 0.996
f 5/5 6/6 7/7 8/8
vt 0.138 0.266
vt 0.132 0.893
vt 0.120 0.321
f 9/9 10/10 11/11
vt 0.144 0.091
vt 0.164 0.877
vt 0.138 0.266
f 12/12 13/13 9/14
vt 0.146 0.004
vt 0.185 0.893
vt 0.144 0.091
f 14/15 15/16 12/17
vt 0.103 0.131
vt 0.075 0.924
vt 0.146 0.004
f 16/18 5/19 14/20
`;

export const jennerRightArmOBJ = `v 140.000 180.000 -30.000
v 140.000 180.000 8.000
v 110.000 190.000 15.000
v 110.000 190.000 -40.000
v 110.000 100.000 -50.000
v 110.000 100.000 30.000
v 140.000 120.000 12.000
v 140.000 120.000 -35.000
v 180.000 50.000 20.000
v 150.000 40.000 25.000
v 120.000 80.000 5.000
v 190.000 30.000 15.000
v 170.000 10.000 5.000
v 130.000 90.000 -15.000
v 155.000 15.000 8.000
v 120.000 85.000 -20.000
vt 0.368 0.282
vt 0.371 0.282
vt 0.373 0.329
vt 0.362 0.345
f 1/1 2/2 3/3 4/4
vt 0.353 0.194
vt 0.374 0.163
vt 0.372 0.210
vt 0.365 0.226
f 5/5 6/6 7/7 8/8
vt 0.144 0.932
vt 0.111 0.901
vt 0.131 0.329
f 9/9 10/10 11/11
vt 0.111 0.901
vt 0.085 0.877
vt 0.110 0.258
f 10/12 12/13 13/14
vt 0.085 0.877
vt 0.065 0.901
vt 0.104 0.083
f 12/15 14/16 15/17
vt 0.065 0.901
vt 0.174 0.932
vt 0.106 0.004
f 14/18 16/19 5/20
`;

export const jennerLeftLegOBJ = `v -80.000 -30.000 40.000
v -80.000 -70.000 40.000
v -110.000 -60.000 100.000
v -150.000 -70.000 40.000
v -150.000 -30.000 40.000
v -150.000 -70.000 150.000
v -80.000 -70.000 150.000
v -130.000 -60.000 100.000
vt 0.086 0.472
vt 0.093 0.480
vt 0.115 0.671
f 1/1 2/2 3/3
vt 0.069 0.726
vt 0.062 0.718
vt 0.108 0.924
f 4/4 5/5 6/6
vt 0.115 0.671
vt 0.093 0.480
vt 0.130 0.671
f 3/7 2/8 7/9
vt 0.108 0.924
vt 0.062 0.718
vt 0.100 0.837
f 6/10 5/11 8/12
vt 0.069 0.726
vt 0.108 0.924
vt 0.130 0.671
vt 0.093 0.480
f 4/13 6/14 7/15 2/16
vt 0.100 0.837
vt 0.062 0.718
vt 0.086 0.472
vt 0.115 0.671
f 8/17 5/18 1/19 3/20
`;

export const jennerRightLegOBJ = `v 80.000 -30.000 40.000
v 80.000 -70.000 40.000
v 130.000 -60.000 100.000
v 150.000 -70.000 40.000
v 150.000 -30.000 40.000
v 150.000 -70.000 150.000
v 80.000 -70.000 150.000
v 110.000 -60.000 100.000
vt 0.137 0.417
vt 0.145 0.425
vt 0.167 0.623
f 1/1 2/2 3/3
vt 0.122 0.671
vt 0.115 0.671
vt 0.159 0.869
f 4/4 5/5 6/6
vt 0.167 0.623
vt 0.145 0.425
vt 0.183 0.615
f 3/7 2/8 7/9
vt 0.159 0.869
vt 0.115 0.671
vt 0.151 0.782
f 6/10 5/11 8/12
vt 0.122 0.671
vt 0.159 0.869
vt 0.183 0.615
vt 0.145 0.425
f 4/13 6/14 7/15 2/16
vt 0.151 0.782
vt 0.115 0.671
vt 0.137 0.417
vt 0.167 0.623
f 8/17 5/18 1/19 3/20
`;

// Raven Light Mech OBJ Data (35 tons - ECM specialist)
export const ravenBodyOBJ = `v 90.000 240.000 -70.000
v 130.000 190.000 -90.000
v 130.000 210.000 -50.000
v -130.000 210.000 -50.000
v -130.000 190.000 -90.000
v -90.000 240.000 -70.000
v 90.000 60.000 -100.000
v 130.000 25.000 -60.000
v -130.000 25.000 -60.000
v -90.000 60.000 -100.000
v 70.000 35.000 50.000
v 100.000 70.000 100.000
v 130.000 25.000 60.000
v -130.000 25.000 60.000
v -100.000 70.000 100.000
v -70.000 35.000 50.000
v 50.000 60.000 130.000
v 50.000 130.000 120.000
v -100.000 110.000 100.000
v -50.000 60.000 130.000
v 100.000 150.000 70.000
v 100.000 110.000 100.000
v -100.000 150.000 70.000
v -50.000 130.000 120.000
v 50.000 170.000 90.000
v 70.000 210.000 50.000
v -70.000 210.000 50.000
v -50.000 170.000 90.000
v 110.000 55.000 -110.000
v -110.000 55.000 -110.000
v 130.000 210.000 20.000
v -130.000 210.000 20.000
v 80.000 260.000 -40.000
v -80.000 260.000 -40.000
vt 0.288 0.694
vt 0.312 0.464
vt 0.312 0.647
f 1/1 2/2 3/3
vt 0.187 0.647
vt 0.187 0.464
vt 0.210 0.694
f 4/4 5/5 6/6
vt 0.288 0.464
vt 0.312 0.052
vt 0.312 0.464
f 7/7 8/8 2/9
vt 0.187 0.464
vt 0.187 0.052
vt 0.210 0.464
f 5/10 9/11 10/12
vt 0.333 0.036
vt 0.318 0.163
vt 0.312 0.052
f 11/13 12/14 13/15
vt 0.437 0.052
vt 0.430 0.163
vt 0.415 0.036
f 14/16 15/17 16/18
vt 0.348 0.155
vt 0.349 0.409
vt 0.318 0.163
f 17/19 18/20 12/21
vt 0.430 0.163
vt 0.430 0.377
vt 0.400 0.155
f 15/22 19/23 20/24
vt 0.349 0.409
vt 0.318 0.528
vt 0.318 0.377
f 18/25 21/26 22/27
vt 0.430 0.377
vt 0.430 0.528
vt 0.399 0.409
f 19/28 23/29 24/30
vt 0.349 0.607
vt 0.335 0.694
vt 0.318 0.528
f 25/31 26/32 21/33
vt 0.430 0.528
vt 0.413 0.694
vt 0.399 0.607
f 23/34 27/35 28/36
vt 0.290 0.036
vt 0.312 0.052
vt 0.288 0.464
f 29/37 8/38 7/39
vt 0.208 0.036
vt 0.290 0.036
vt 0.288 0.464
vt 0.210 0.464
f 30/40 29/41 7/42 10/43
vt 0.318 0.528
vt 0.335 0.694
vt 0.312 0.647
f 21/44 26/45 31/46
vt 0.437 0.647
vt 0.413 0.694
vt 0.430 0.528
f 32/47 27/48 23/49
vt 0.499 0.694
vt 0.512 0.996
vt 0.486 0.996
f 33/50 1/51 6/52
vt 0.486 0.996
vt 0.499 0.694
vt 0.512 0.996
f 6/53 34/54 33/55
`;

export const ravenLeftArmOBJ = `v -130.000 170.000 -25.000
v -100.000 180.000 -35.000
v -100.000 180.000 12.000
v -130.000 170.000 5.000
v -100.000 90.000 -45.000
v -130.000 110.000 -30.000
v -130.000 110.000 10.000
v -100.000 90.000 25.000
v -170.000 45.000 15.000
v -110.000 75.000 0.000
v -140.000 35.000 20.000
v -180.000 25.000 10.000
v -120.000 85.000 -10.000
v -160.000 8.000 2.000
v -110.000 80.000 -15.000
v -145.000 12.000 5.000
v -190.000 30.000 25.000
v -150.000 20.000 30.000
vt 0.312 0.678
vt 0.374 0.615
vt 0.374 0.869
vt 0.312 0.805
f 1/1 2/2 3/3 4/4
vt 0.249 0.496
vt 0.187 0.631
vt 0.187 0.853
vt 0.249 0.996
f 5/5 6/6 7/7 8/8
vt 0.138 0.266
vt 0.132 0.893
vt 0.120 0.321
f 9/9 10/10 11/11
vt 0.144 0.091
vt 0.164 0.877
vt 0.138 0.266
f 12/12 13/13 9/14
vt 0.146 0.004
vt 0.185 0.893
vt 0.144 0.091
f 14/15 15/16 12/17
vt 0.103 0.131
vt 0.075 0.924
vt 0.146 0.004
f 16/18 17/19 14/20
vt 0.120 0.321
vt 0.103 0.924
vt 0.103 0.131
f 11/21 18/22 16/23
`;

export const ravenRightArmOBJ = `v 130.000 170.000 -25.000
v 130.000 170.000 5.000
v 100.000 180.000 12.000
v 100.000 180.000 -35.000
v 100.000 90.000 -45.000
v 100.000 90.000 25.000
v 130.000 110.000 10.000
v 130.000 110.000 -30.000
v 170.000 45.000 15.000
v 140.000 35.000 20.000
v 110.000 75.000 0.000
v 180.000 25.000 10.000
v 160.000 8.000 2.000
v 120.000 85.000 -10.000
v 145.000 12.000 5.000
v 110.000 80.000 -15.000
v 190.000 30.000 25.000
v 150.000 20.000 30.000
vt 0.368 0.282
vt 0.371 0.282
vt 0.373 0.329
vt 0.362 0.345
f 1/1 2/2 3/3 4/4
vt 0.353 0.194
vt 0.374 0.163
vt 0.372 0.210
vt 0.365 0.226
f 5/5 6/6 7/7 8/8
vt 0.144 0.932
vt 0.111 0.901
vt 0.131 0.329
f 9/9 10/10 11/11
vt 0.111 0.901
vt 0.085 0.877
vt 0.110 0.258
f 10/12 12/13 13/14
vt 0.085 0.877
vt 0.065 0.901
vt 0.104 0.083
f 12/15 14/16 15/17
vt 0.065 0.901
vt 0.174 0.932
vt 0.106 0.004
f 14/18 16/19 5/20
vt 0.174 0.932
vt 0.144 0.932
vt 0.145 0.131
f 16/21 17/22 18/23
`;

export const ravenLeftLegOBJ = `v -70.000 -25.000 35.000
v -70.000 -65.000 35.000
v -100.000 -55.000 95.000
v -140.000 -65.000 35.000
v -140.000 -25.000 35.000
v -140.000 -65.000 140.000
v -70.000 -65.000 140.000
v -120.000 -55.000 95.000
vt 0.086 0.472
vt 0.093 0.480
vt 0.115 0.671
f 1/1 2/2 3/3
vt 0.069 0.726
vt 0.062 0.718
vt 0.108 0.924
f 4/4 5/5 6/6
vt 0.115 0.671
vt 0.093 0.480
vt 0.130 0.671
f 3/7 2/8 7/9
vt 0.108 0.924
vt 0.062 0.718
vt 0.100 0.837
f 6/10 5/11 8/12
vt 0.069 0.726
vt 0.108 0.924
vt 0.130 0.671
vt 0.093 0.480
f 4/13 6/14 7/15 2/16
vt 0.100 0.837
vt 0.062 0.718
vt 0.086 0.472
vt 0.115 0.671
f 8/17 5/18 1/19 3/20
vt 0.100 0.837
vt 0.115 0.671
vt 0.130 0.671
vt 0.108 0.924
f 8/21 3/22 7/23 6/24
vt 0.093 0.480
vt 0.086 0.472
vt 0.062 0.718
vt 0.069 0.726
f 2/25 1/26 5/27 4/28
`;

export const ravenRightLegOBJ = `v 70.000 -25.000 35.000
v 70.000 -65.000 35.000
v 120.000 -55.000 95.000
v 140.000 -65.000 35.000
v 140.000 -25.000 35.000
v 140.000 -65.000 140.000
v 70.000 -65.000 140.000
v 100.000 -55.000 95.000
vt 0.137 0.417
vt 0.145 0.425
vt 0.167 0.623
f 1/1 2/2 3/3
vt 0.122 0.671
vt 0.115 0.671
vt 0.159 0.869
f 4/4 5/5 6/6
vt 0.167 0.623
vt 0.145 0.425
vt 0.183 0.615
f 3/7 2/8 7/9
vt 0.159 0.869
vt 0.115 0.671
vt 0.151 0.782
f 6/10 5/11 8/12
vt 0.122 0.671
vt 0.159 0.869
vt 0.183 0.615
vt 0.145 0.425
f 4/13 6/14 7/15 2/16
vt 0.151 0.782
vt 0.115 0.671
vt 0.137 0.417
vt 0.167 0.623
f 8/17 5/18 1/19 3/20
vt 0.151 0.782
vt 0.167 0.623
vt 0.183 0.615
vt 0.159 0.869
f 8/21 3/22 7/23 6/24
vt 0.122 0.671
vt 0.145 0.425
vt 0.137 0.417
vt 0.115 0.671
f 4/25 2/26 1/27 5/28
`;